import AttendeeCarousel from '~/components/attendees/AttendeeCarousel';

const OtherAttendees = AttendeeCarousel;

export default OtherAttendees;
